import { render } from "./ImportantNotice.vue?vue&type=template&id=538d68a1&scoped=true&ts=true"
import script from "./ImportantNotice.vue?vue&type=script&lang=ts"
export * from "./ImportantNotice.vue?vue&type=script&lang=ts"

import "./ImportantNotice.vue?vue&type=style&index=0&id=538d68a1&scoped=true&lang=css"

import exportComponent from "D:\\Users\\Sean\\Documents\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-538d68a1"]])

export default __exports__